import { useState } from 'react';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import { getByok, setByok } from '../lib/photoAi';

const MODELS = { openai: ['gpt-5.4', 'gpt-5.4-mini', 'gpt-5.5', 'gpt-4.1'], anthropic: ['claude-sonnet-4-6', 'claude-sonnet-5-5', 'claude-haiku-4-5-20251001'], gemini: ['gemini-3-flash-preview', 'gemini-3.1-pro-preview', 'gemini-2.5-flash'] };

// customer's own AI model + key for all AI helpers (photo texts, books, inventory, leak measure); LeakBuster stays the assistant
export default function AiKeySettings({ t }) {
  const [v, setV] = useState(() => ({ on: false, provider: 'openai', model: '', key: '', ...getByok() }));
  const save = (on = v.on) => { const n = { ...v, on: on && !!v.key.trim(), key: v.key.trim() }; setByok(n); setV(n); toast.success(n.on ? t.akOn : t.akOff); };
  return (
    <details className="md-block" data-testid="settings-ai-key">
      <summary data-testid="settings-ai-key-toggle"><KeyRound size={14} /> {t.akTitle}</summary>
      <p className="muted small-hint">{t.akHint}</p>
      <div className="row">
        <label className="pit-num"><span>{t.akProvider}</span>
          <select data-testid="ai-key-provider" value={v.provider} onChange={(e) => setV({ ...v, provider: e.target.value, model: '' })}>
            <option value="openai">OpenAI (GPT)</option><option value="anthropic">Anthropic (Claude)</option><option value="gemini">Google (Gemini)</option>
          </select></label>
        <label className="pit-num"><span>{t.akModel}</span>
          <input list="ak-models" data-testid="ai-key-model" value={v.model} placeholder={MODELS[v.provider][0]} onChange={(e) => setV({ ...v, model: e.target.value })} />
          <datalist id="ak-models">{MODELS[v.provider].map((m) => <option key={m} value={m} />)}</datalist></label>
      </div>
      <input type="password" autoComplete="off" className="offer-in" data-testid="ai-key-input" placeholder={t.akKeyPh} value={v.key} onChange={(e) => setV({ ...v, key: e.target.value })} />
      <div className="row">
        <button type="button" className="btn btn-green btn-sm" data-testid="ai-key-save" disabled={!v.key.trim()} onClick={() => save(true)}>{t.akUse}</button>
        {v.on && <button type="button" className="btn btn-outline btn-sm" data-testid="ai-key-off" onClick={() => save(false)}>{t.akStop}</button>}
        <span className="muted" data-testid="ai-key-state">{v.on ? `${t.akActive}: ${v.provider} · ${v.model || MODELS[v.provider][0]}` : t.akApp}</span>
      </div>
    </details>
  );
}
